import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgLuggageModern = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.46 1.042a1 1 0 0 0-1 1v5.06H9.95A2.51 2.51 0 0 0 7.44 9.61v1.422h1V9.611c0-.834.677-1.51 1.51-1.51h8.04c.834 0 1.51.676 1.51 1.51v9.437a1.51 1.51 0 0 1-1.51 1.51h-3.537v1h2.153v1.376h1v-1.376h.384a2.51 2.51 0 0 0 2.51-2.51V9.611a2.51 2.51 0 0 0-2.51-2.51h-1.51V2.042a1 1 0 0 0-1-1h-3.02Zm1.51 6.06h1.51v-5.06h-3.02v5.06h1.51Zm-9.429 6.925h1.182a2.222 2.222 0 0 1 2.046-2.101 2.078 2.078 0 0 1 1.642.586c.37.365.615.876.698 1.515h1.23c.442 0 .765.297.97.558.219.279.4.638.542.998.283.714.469 1.566.469 2.093v3.222c0 1.126-.847 2.114-1.98 2.114H4.54c-1.133 0-1.98-.988-1.98-2.114v-3.222c0-.527.186-1.379.469-2.093.143-.36.323-.72.542-.998.205-.26.528-.558.97-.558Zm3.4 0H6.728a1.215 1.215 0 0 1 1.122-1.104c.317-.026.627.072.859.301.166.164.317.42.388.803H7.941Zm-4.38 3.65c0-.365.146-1.088.399-1.726.125-.315.263-.576.399-.749.114-.145.179-.17.189-.175h6.785c.01.004.075.03.19.175.135.173.273.434.398.75.253.637.399 1.36.399 1.724v3.222c0 .657-.48 1.114-.98 1.114H4.54c-.5 0-.98-.457-.98-1.114v-3.222Z"
      fill="#000"
    />
  </svg>
);
const Memo = memo(SvgLuggageModern);
export default Memo;
